import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

// Import pages
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import Entities from './pages/Entities';
import Payroll from './pages/Payroll';
import Settings from './pages/Settings';
import Login from './pages/Login';

// Import reports pages
import ReportsIndex from './pages/reports/index';
import ReportsUpload from './pages/reports/upload';
import SessionReport from './pages/reports/[sessionId]';
import CreateBlog from './pages/blogs/CreateBlog';

// Import components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/employees"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Employees />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/entities"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Entities />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/payroll"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Payroll />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ReportsIndex />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/upload"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ReportsUpload />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/:sessionId"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SessionReport />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Settings />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/blogs"
              element={
                <ProtectedRoute>
                  <Layout>
                    <CreateBlog />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 